import { Injectable } from '@angular/core';
import { MiaHttpService, ApiResponse, MIATableModel, ApiPagination } from '@mobileia/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Product } from '../entities/product';
import { AuthenticationService, MiaAuthHttpService } from '@mobileia/authentication';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends MiaAuthHttpService {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
  }

  fetchById(productId: number): Observable<ApiResponse<Product>> {
    return this.postObject(environment.baseUrl + 'product/fetch', { id: productId });
  }

  fetchListOrderByLastFeatured(): Observable<ApiResponse<ApiPagination<Product>>> {
    let params = new MIATableModel();
    params.addWhere('status', '1');
    params.addWhere('is_feature', '1');
    params.ordType = { title: 'id', asc: 0};
    return this.fetchList(params);
  }

  fetchListOrderByViews(): Observable<ApiResponse<ApiPagination<Product>>> {
    let params = new MIATableModel();
    params.addWhere('is_feature', '1');
    params.addWhere('status', '1');
    params.ordType = { title: 'views', asc: 1};
    return this.fetchList(params);
  }

  fetchListOrderBySales(): Observable<ApiResponse<ApiPagination<Product>>> {
    let params = new MIATableModel();
    params.addWhere('is_feature', '1');
    params.addWhere('status', '1');
    params.ordType = { title: 'sales', asc: 1};
    return this.fetchList(params);
  }

  fetchList(params: MIATableModel): Observable<ApiResponse<ApiPagination<Product>>> {
    return this.postAuthObject(environment.baseUrl + 'product/list', params.toParams());
  }

  fetchInOffer(): Observable<ApiResponse<Array<Product>>> {
    return this.postObject(environment.baseUrl + 'product/in-offer', {});
  }

  calculateShipping(productId: number, zipCode: string, quantity: number): Observable<ApiResponse<any>> {
    return this.postObject(environment.baseUrl + 'shipping/oca-product', {
      product_id: productId,
      zip_code: zipCode,
      quantity: quantity
    });
  }
}
